import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/PALC_Marque_Black.svg")